import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';

import { ViewBillMonthlyUsage } from '../../../__generated__/pge-types';
import { useTranslation } from '../../../hooks/useTranslation';

export interface UsageGraphProps {
  monthUsage: ViewBillMonthlyUsage | undefined | null;
  isMobile?: boolean;
}

const UsageGraph = ({ monthUsage, isMobile = false }: UsageGraphProps) => {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return (monthUsage?.usages || []).reduce(
      (acc, month) => {
        acc.labels.push(month?.monthName?.substr(0, 3) || '');
        acc.datasets[0].data.push(month?.totalKwh || 0);
        return acc;
      },
      {
        labels: [] as string[],
        datasets: [
          {
            label: 'kWh per Month',
            backgroundColor: 'red',
            borderColor: 'rgb(3, 112, 180)',
            borderWidth: 1,
            hoverBackgroundColor: 'rgb(4,144,230)',
            hoverBorderColor: 'rgb(4,144,230)',
            data: [] as any,
          },
        ],
      },
    );
  }, [monthUsage?.usages, isMobile]);

  if (
    (monthUsage?.usages || []).every(
      (m: any) => m?.totalKwh === 0 || !m?.totalKwh,
    )
  ) {
    return null;
  }

  const hasPreviousYear =
    monthUsage?.usages?.length! >= new Date().getMonth() + 1;

  const year = new Date().getFullYear();

  return (
    <div style={{ position: 'relative', overflowX: 'scroll' }}>
      <Bar
        data={data}
        legend={null}
        redraw={true}
        options={{
          responsive: true,
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'kWh',
                },
              },
            ],
            xAxes: [
              {
                barThickness: 'flex',
                maxBarThickness: isMobile ? 28 : 40,
                scaleLabel: {
                  display: true,
                  labelString: `${
                    hasPreviousYear ? year - 1 : year
                  }               ${t('MONTHS')}               ${year}`,
                },
              },
            ],
          },
        }}
        height={250}
        width={700}
      />
    </div>
  );
};

export default UsageGraph;
